import { CONFIG } from '@hero/core';
import { useMemo } from 'react';

const options = CONFIG.order.cancelConfig.cancelOptions;

export const useOrderCancelOptions = () => {
  const customerOptions = useMemo(() => {
    return options.filter(option => option.target.includes('customer'));
  }, []);

  const adminOptions = useMemo(() => {
    return options;
  }, []);

  const carrierOptions = useMemo(() => {
    return options.filter(option => option.target.includes('carrier'));
  }, []);

  return {
    adminOptions,
    customerOptions,
    carrierOptions,
  };
};
